import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'svc-highlight-group',
  templateUrl: './svc-highlight-group.component.html',
  styleUrls: ['./svc-highlight-group.component.scss'],
})
export class SvcHighlightGroupComponent implements AfterViewInit {
  @Input() svgIcon: string = 'mat_solid:date_range';

  @ViewChild('containerContent') containerContent!: ElementRef<HTMLDivElement>;

  public showButtons = { right: false, left: false };

  #scrollTimeout!: ReturnType<typeof setTimeout>;

  scroll(direction: 'left' | 'right'): void {
    const scroll = this.#getScrollPosition();
    const amount = Math.max(0, Math.min(scroll.scrollWidth - scroll.clientWidth, scroll.scrollLeft + (direction === 'left' ? -100 : 100)));

    this.containerContent.nativeElement.scrollTo({ left: amount, behavior: 'smooth' });

    clearTimeout(this.#scrollTimeout);

    let limit = 0;
    this.#scrollTimeout = setInterval(() => {
      limit++;
      const scroll = this.#getScrollPosition();
      if (limit > 10 || direction === 'left' ? scroll.scrollLeft <= amount : scroll.scrollLeft >= amount) {
        clearInterval(this.#scrollTimeout);
        setTimeout(() => this.#updateButtonsVisibility());
      }
    }, 50);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      const scroll = this.#getScrollPosition();
      this.showButtons.right = scroll.scrollWidth >= scroll.scrollLeft + scroll.clientWidth;
      this.showButtons.left = scroll.scrollLeft > 0;
    });
  }

  #getScrollPosition(): { scrollWidth: number; clientWidth: number; scrollLeft: number } {
    return {
      scrollWidth: this.containerContent.nativeElement.scrollWidth,
      clientWidth: this.containerContent.nativeElement.clientWidth,
      scrollLeft: this.containerContent.nativeElement.scrollLeft,
    };
  }

  #updateButtonsVisibility(): void {
    const scroll = this.#getScrollPosition();
    this.showButtons.right = scroll.scrollLeft < scroll.scrollWidth - scroll.clientWidth;
    this.showButtons.left = scroll.scrollLeft > 0;
  }
}
